import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import SignIn from './SignIn';
import SetPassword from './SetPassword';
import Register from './Register';
import '../../styles/signIn.scss';

// Magic link de auto-registro: ?registro=<secret>. Si está presente y no hay
// sesión, AuthGate muestra la pantalla de registro en vez de la de login.
const signupSecret = new URLSearchParams(window.location.search).get('registro');

const AuthGate = ({ children }) => {
  const { user, loading, recoveryMode } = useContext(AuthContext);

  if (loading) {
    return (
      <div className="auth-page">
        <div className="auth-loading">Loading...</div>
      </div>
    );
  }

  if (recoveryMode) {
    return <SetPassword />;
  }

  if (!user) {
    if (signupSecret) {
      return <Register secret={signupSecret} />;
    }
    return <SignIn />;
  }

  return children;
};

export default AuthGate;
